import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import textService from '../services/text';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import Title from '../components/title/title';
import Menu from '../components/menu/menu';
import Gallery from '../components/gallery/gallery';
import List from '../components/list/list';
import Meta from '../components/meta/meta';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const header = document.querySelector('.patio-purpura-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;

      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          const top = element.offsetTop - headerHeight;
          window.scrollTo({
            top: top
          });
        }
      }, 1000);
    }
  }, [location.hash]);

  return (
    <div className="patio-purpura">
      <Meta 
        title="Patio Púrpura - Pan de Masa Madre Artesanal"
        description="Emprendimiento de una tica amante del pan y del buen café. Pan artesanal hecho en casa con paciencia y amor. Porque todo lo bueno toma su tiempo."
        keywords="pan, masa madre, artesanal, Costa Rica, sourdough, pan casero, pan fresco"
      />
      <Header />

      <main className="patio-purpura-content">
        <section className="hero-section">
          <div className="hero-content">
            <Title myTitle={textService.getMainTitle()} />
            <p className="main-description">{textService.getMainDescription()}</p>
            <div className="hero-cta">
              <a href="#menu" className="cta-button primary">Ver Nuestros Panes</a>
              <a href="/contactenos" className="cta-button secondary">Hacer Pedido</a>
            </div>
          </div>
        </section>

        <section id="gallery" className="gallery-section">
          <Gallery />
        </section>

        <section id="menu" className="menu-section">
          <Menu />
        </section>

        <section id="sourdough" className="sourdough-section">
          <div className="section-content">
            <Title myTitle={textService.getWhatIsSourdoughTitle()} />
            <List items={textService.getSourdoughExplanation()} />
          </div>
        </section>

        <section id="benefits" className="benefits-section">
          <div className="section-content">
            <Title myTitle={textService.getBenefitsTitle()} />
            <List items={textService.getSourdoughBenefits()} />
          </div>
        </section>

        <section className="cta-section">
          <div className="cta-content">
            <h2>¿Listo para probar nuestros panes?</h2>
            <p>Haz tu pedido <strong>antes del martes</strong> y recibe tu pan fresco jueves o viernes</p>
            <div className="cta-buttons">
              <a href="/contactenos" className="cta-button primary">Hacer Pedido</a>
              <a href="https://wa.me/50688644774" className="cta-button whatsapp" target="_blank" rel="noopener noreferrer">
                💬 WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Home;